export const EVENT_NAVIGATION_CLICK = "click";
export const MOVE_DIRECTION_LEFT = "left";
export const MOVE_DIRECTION_RIGHT = "right";

enum NavigationSize {
  SM = "sm",
  MD = "md",
}
export { NavigationSize };
